import { ApplicationAvatar, DataGridLoading, FormContent, FormDrawer, FormFooter, FormHeader } from "Common/Components";
import { useMyProfile } from "./Hooks";
import React from "react";
import Grid from "@mui/material/Grid";
import { Avatar, ListItemText, Stack, Tooltip, Typography } from "@mui/material";
import { stringAvatar } from "Common/Functions";
import { DetailItem, LabelBox } from "./Components";
import { LABEL_VALUES } from "./Constants";

interface IMyProfile {
  open: boolean;
  handleClose: () => void;
}

export const MyProfile: React.FC<IMyProfile> = (props) => {
  const { open, handleClose } = props;

  const { isUserDetailsLoading, userDetails } = useMyProfile();

  return (
    <FormDrawer open={open}>
      <FormHeader title="My Profile" handleClose={handleClose} />
      <FormContent>
        <DataGridLoading isLoading={isUserDetailsLoading}>
          <React.Fragment>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Avatar
                sx={(theme) => ({
                  width: 76,
                  height: 76,
                  fontWeight: theme.typography.fontWeightRegular,
                  bgcolor: theme.palette.primary.main,
                })}
                {...stringAvatar(userDetails?.displayName ?? "")}
              />
              <Tooltip title={`${userDetails?.displayName ?? ""}\n${userDetails?.email ?? ""}`}>
                <ListItemText
                  primary={userDetails?.displayName ?? ""}
                  secondary={userDetails?.email ?? ""}
                  slotProps={{
                    primary: {
                      variant: "h6",
                      noWrap: true,
                    },
                    secondary: {
                      variant: "body1",
                      noWrap: true,
                    },
                  }}
                />
              </Tooltip>
            </Stack>

            <Stack
              direction="row"
              spacing={2}
              sx={{
                pt: 3,
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <LabelBox primary={LABEL_VALUES.ENTITY_TYPE} secondary={userDetails?.entity?.typeName ?? ""} />
              <LabelBox primary={LABEL_VALUES.ENTITY_NAME} secondary={userDetails?.entity?.displayName ?? ""} />
              <LabelBox primary={LABEL_VALUES.ROLE} secondary={userDetails?.role?.displayName ?? ""} />
            </Stack>

            <Grid
              container
              sx={{
                pt: 3,
              }}
            >
              <Grid size={12}>
                <Typography variant="h6">Account Information</Typography>
              </Grid>
            </Grid>
            <Stack
              sx={{
                pt: 2,
              }}
              spacing={2}
            >
              <Stack direction="row" spacing={4}>
                <DetailItem
                  primary={LABEL_VALUES.FIRST_NAME}
                  secondary={userDetails?.firstName ?? ""}
                  sx={{
                    width: "50%",
                  }}
                />
                <DetailItem
                  sx={{
                    width: "50%",
                  }}
                  primary={LABEL_VALUES.LAST_NAME}
                  secondary={userDetails?.lastName ?? ""}
                />
              </Stack>
              {userDetails?.mobile && (
                <Stack direction="row" spacing={4}>
                  <DetailItem primary={LABEL_VALUES.MOBILE_PHONE} secondary={userDetails.mobile ?? ""} />
                </Stack>
              )}
              {userDetails?.work && (
                <Stack direction="row" spacing={4}>
                  <DetailItem primary={LABEL_VALUES.WORK_PHONE} secondary={userDetails.work ?? ""} />
                </Stack>
              )}
              {userDetails?.jobTitle && (
                <Stack direction="row" spacing={4}>
                  <DetailItem primary={LABEL_VALUES.JOB_TITLE} secondary={userDetails.jobTitle ?? ""} />
                </Stack>
              )}
            </Stack>

            <Grid
              container
              sx={{
                pt: 6,
              }}
            >
              <Grid size={12}>
                <Typography variant="h6">My Applications</Typography>
              </Grid>
            </Grid>
            <Stack
              sx={{
                pt: 2,
              }}
              spacing={2}
            >
              {userDetails?.applications?.map(({ id, displayName, description, logoURL }) => {
                return <ApplicationAvatar key={id} name={displayName} description={description} logoLink={logoURL} />;
              })}
            </Stack>
          </React.Fragment>
        </DataGridLoading>
      </FormContent>
      <FormFooter
        buttons={[
          {
            label: "Close",
            variant: "contained",
            onClick: handleClose,
          },
        ]}
      />
    </FormDrawer>
  );
};
